module.exports = __webpack_public_path__ + "media/goforajourney/img/our-professionals-ef74b2e5efaddc721689d0919b0c21a7.png";